import CreateStore from './containers/CreateStore';
import epics from './services/epics';

export default CreateStore;

export { epics };



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/index.ts